import { compose, withHandlers, withProps } from 'recompose'
import StoreRating from './StoreRating'
import { OPEN_TRUMPET_REVIEWS_TAB } from 'constant'
import { QUALTRICS_SURVEY_URL } from 'components/StoreDetailsPage/constants'

const withTrumpetRatingProps = withProps(({
  storeNum,
  ratingData: {
    AverageRating: ratingCount,
    TotalNumberRatings: reviewsCount
  } = {}
}) => ({
  writeReviewUrl: QUALTRICS_SURVEY_URL,
  ratingValues: {
    ratingCount,
    reviewsCount
  }
}))

const withOpenReviewsTabOnClick = withHandlers({
  openReviewsTabHandler: () => () => window.dispatchEvent(new CustomEvent(OPEN_TRUMPET_REVIEWS_TAB))
})

export default compose(
  withTrumpetRatingProps,
  withOpenReviewsTabOnClick
)(StoreRating)
